import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE
} from '@/lib/socialProfile';

export const AlbumCardAnalyticsIconsForGroups = {
    media_views: 'impressions',
    media_reach: 'reach',
    engagement: 'engagement'
} as const;

export const AlbumCardAnalyticsIconsForGroupStories = {
    average_stories_views: 'impressions',
    average_stories_reach: 'reach',
    average_stories_reach_rate: 'reach'
} as const;

export const AlbumCardAnalyticsIcons = {
    [INSTAGRAM]: {
        likes: 'likes',
        comments: 'comments',
        average_engagement_rate_per_post: 'engagement',
        average_stories_views: 'impressions',
        average_stories_reach: 'reach',
        average_stories_reach_rate: 'reach'
    },
    [FACEBOOK]: {
        clicks: 'click',
        comments: 'comments',
        reactions: 'reaction'
    },
    [TWITTER]: {
        likes: 'likes',
        replies: 'replies',
        average_engagement_rate_per_post: 'engagement'
    },
    [LINKEDIN]: {
        reactions: 'reaction',
        comments: 'comments',
        average_engagement_rate_per_post: 'engagement'
    },
    [TIKTOK_BUSINESS]: {
        likes: 'likes',
        comments: 'comments',
        views: 'impressions'
    },
    [YOUTUBE]: {
        media_likes: 'reaction',
        media_comments: 'comments',
        media_views: 'impressions'
    },
    [PINTEREST]: {
        reactions: 'reaction',
        comments: 'comments',
        engagement: 'engagement'
    }
} as const;

export const FbPostIcons = {
    story: 'link',
    mobile_status: 'text'
} as const;

export const FbMediaTypesWithIcon = ['story', 'mobile_status'] as const;

export const TwPostIcons = {
    photo: 'content',
    carousel: 'carousel',
    video: 'video',
    status: 'text',
    quote: 'quotes',
    link: 'link',
    retweet: 'retweet',
    poll: 'poll',
    reply: 'reply'
} as const;

export function getTwMediaType(type: keyof typeof TwPostIcons, sub_type: keyof typeof TwPostIcons) {
    if (sub_type === 'poll' || sub_type === 'reply') {
        return sub_type;
    }
    return type;
}

export const LiPostIcons = {
    photo: 'content',
    carousel: 'carousel',
    video: 'video',
    status: 'text',
    link: 'link',
    document: 'doc',
    poll: 'poll'
} as const;

export const YtPostIcons = {
    video: 'video',
    short: 'story'
} as const;

export const PiPostIcons = {
    image: 'content',
    'carousel-images': 'carousel-images',
    'carousel-mixed': 'carousel',
    'carousel-videos': 'carousel-videos',
    video: 'video'
} as const;

export const AlbumCardPostIcons = {
    [FACEBOOK]: FbPostIcons,
    [TWITTER]: TwPostIcons,
    [LINKEDIN]: LiPostIcons
};

type getCardPostIconClassesType =
    | keyof typeof FbPostIcons
    | keyof typeof TwPostIcons
    | keyof typeof LiPostIcons;
export function getCardPostIconClasses(type: getCardPostIconClassesType) {
    switch (type) {
        case 'carousel':
        case 'video':
        case 'photo':
            return 'bg-icoBlue-100 text-icoBlue';
        case 'status':
        case 'mobile_status':
            return 'bg-icoGray-100 text-icoGray-500';
        case 'story':
        case 'link':
            return 'bg-icoPink-100 text-icoPink';
        case 'document':
            return 'bg-icoPurple-100 text-icoPurple';
        case 'reply':
            return 'bg-icoYellow-100 text-icoYellow';
        case 'poll':
            return 'bg-icoOrange-100 text-icoOrange';
        case 'retweet':
            return 'bg-icoGreen-100 text-icoGreen';
        case 'quote':
            return 'bg-icoAquaBlue-100 text-icoAquaBlue';
    }
}
